import React, { useState, useContext, useEffect,useRef } from 'react';
import '../../../assets/css/chatEstilos.css'
import '../../../assets/css/views/recargas.css'
import { useIframeComm } from 'react-iframe-comm';


import { Modal } from '../../components/modal/Modal';

import { ModalRecarga } from '../../components/modal/ModalRecarga';
import { DatePickerABX } from '../../components/pickers/DatePicker';

import { BotonesEstado } from '../../components/buttons/BotonEstado';
import { notify, soloDecimal, formatState } from '../../../utils/utils'
import { SocketContext } from '../../../context/provider/SocketProvider'
import { Tooltip } from '../../components/utils/Tooltip';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { useRecargas } from '../../../hooks/useRecargas';
import { useModal } from '../../../hooks/useModal';
import sonidoRecarga from '../../../assets/sound/sonidoRecarga.mp3'
import { useHistorialRecargas } from '../../../hooks/useHistorialRecargas';
import { useAmonestaciones } from '../../../hooks/useAmonestaciones';
import { SearchTable } from '../../components/utils/SearchTable';
import { UserContext } from '../../../context/provider/UserProvider';
import { useChatOnline } from '../../../hooks/useChatOnline';
import fotoChat from '../../../../src/assets/images/fotousuarioBeex.fw.png'
import fotobeexserver from '../../../../src/assets/images/fotousuarioBeexserver.fw.png'
import { soloNumero } from '../../../utils/utils';
import { useImagenaTexto } from '../../../hooks/useImagenaTexto';
import { useOperaciones } from '../../../hooks/useOperaciones';


export const RecargasV2 = () => {
    
    const [ switchDiponible , setSwitchDiponible ] = useState(true)
    const [cargando, setCargando] = useState(false)

    const {
        recargas,
        listarRecargas,
        recarga,
        spinner,
        isOpenObtenerRecarga,
        closeModalObtenerRecarga,
        editarValorRecarga,
        obtenerRecarga,
        estadoBotonPintar,
        setEstadoBotonPintar,
        aceptarRecarga,
        rechazarRecarga,
        isOpenModalDenegar,
        openModalDenegar,
        closeModalDenegar,
        bancos,
        fotoRecarga,
        listarEntidadesBancarias,
        validarNroOperacion,
        nroOperacionValido

        } = useRecargas();

    const {        
        extraerTexto,
        textoConvertido,
        loadingConversion
    } = useImagenaTexto()

    const cambiarEstadoUsuario = ()=>{
        setSwitchDiponible(!switchDiponible)
    }


    const iframeRef = useRef(null);

    const loadURL = () => {
        notify("intentando conectarse al iframe ", "warning")
      const url = 'https://www.bbva.pe/'; // Reemplaza con la URL que desees cargar
      iframeRef.current.src = url;
    };
  



    useEffect(()=>{
        if(textoConvertido.isValid === true){
            notify(
                `Banco: ${textoConvertido.content.entidad_destino}\nFecha: ${textoConvertido.content.fecha_hora}\nN° Operación: ${textoConvertido.content.numero_operacion}\nMonto: S/${textoConvertido.content.monto}`,
                'success'
            );            editarValorRecarga('nomEntidadBancaria', textoConvertido.content.entidad_destino)
            editarValorRecarga('montoVoucher', textoConvertido.content.monto)
            editarValorRecarga('fechaOperacion', textoConvertido.content.fecha_hora)
            editarValorRecarga('nroOperacion', textoConvertido.content.numero_operacion)
        }
    },[loadingConversion])
    
    const { chat ,obtenerChat, isOpenChat, openModalChat, closeModalChat, editarValorChat, guardarEditarMensaje } = useChatOnline();



    const audioRecarga = useRef(null);
    const classNameInput2 = "p-2 caret-input text-white containerScroll h-[60px] rounded mt-[5px] px-2 w-full bg-zinc-900 text-base focus:outline-none focus:ring-1 focus:ring-blue-500"
    const classNameInput = " caret-input  text-white h-[30px] rounded px-2 w-[240px] bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center  caret-input"
    const [ startDate, setStartDate ] = useState(new Date())
    const [ endDate, setEndDate ] = useState(new Date())
    const [ recargaDate, setRecargaDate ] = useState(new Date())
    const [ verInputComentarioBloqueo, setVerInputComentarioBloqueo ] = useState(false)
    const { listarHistorialRecargas, recargaHistorial, isOpenHistorial, closeModalHistorial } = useHistorialRecargas()
    const { stateSocket } = useContext(SocketContext);
    const { stateUser, signIn } = useContext(UserContext);
    const [ isOpenChatBeex, openModalChatBeex, closeModalChatBeex ] = useModal()
    const [ isOpenModalRecarga, openModalRecarga, closeModalRecarga ] = useModal()
    const [ isOpenModalCuentas, openModalCuentas, closeModalCuentas ] = useModal()
    const [ urlBancoElegido , setUrlBancoElegido ] = useState()
    const [ imagenBanco, setImagenBanco ] = useState("https://static.vecteezy.com/system/resources/previews/020/716/209/original/flat-icon-bank-bank-icon-where-to-keep-money-illustration-of-saving-in-the-bank-free-png.png")
    const ultimoElementoRef = useRef(null);
    const idTablaRecargas = "tablaRecargas"
    const sevenDaysAgo = new Date(); // Crear una nueva instancia de Date
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Restar 7 días

    const {         
        listarOperaciones,
        verificarInicioOperacion,
        operaciones,
        operacion,
        iniciarOperacion,
        finalizarOperacion,
        operacionActiva,
        resumenMontoOperaciones,
        isOpenModalResumenMonto ,
        closeModalResumenMonto,
        listarResumenMontos     
    } = useOperaciones()

    useEffect(() => {
        setStartDate(sevenDaysAgo); // Establecer la fecha con 7 días antes
    }, []); // Asegurarse de que esto se ejecute solo una vez al montar el componente

    useEffect(() => {
        listarRecargas(startDate,endDate,0);
    }, [])
    
    useEffect(()=>{
        listarEntidadesBancarias()
    },[])

    
    useEffect(()=>{
        const usuarioSocket= {
            usuario : stateUser.nomUsuario.toUpperCase(),
            sesion : localStorage.getItem('sesion'),
            token: stateUser.token
        }
    },[])


    useEffect(() => { //Notificacion MQTT
        if (Object.keys(stateSocket.payload).length > 0) {
            audioRecarga.current.play(); 
            if (stateSocket.payload.message.hd.cmd == "setNotificacionBeexManager"){ //notificacion de chat
                notify('¡Se recibio un nuevo mensaje!', 'info', { autoClose: true });
                listarRecargas(startDate,endDate,52);
                if(isOpenChatBeex){
                    obtenerChat(recarga.codPeticion)
                }else{
                }
            }else{// notificacion de nueva recarga
                listarRecargas(startDate,endDate,50);
                notify('¡Se Envió una Recarga!', 'info', { autoClose: true });
            }
        }
    }, [stateSocket.payload])


    
    const handleFocus = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
        }
    };

    const abrirChat=(chat)=>{
        obtenerChat(chat)
        // closeModal()
        openModalChatBeex()
        editarValorChat('chatActivo', true)
    }


    const enviarMensaje = (chat)=>{
        guardarEditarMensaje()
        // chat.mensaje = ""
        obtenerChat(chat)
    
    }
    useEffect(()=>{
    
        if(operacionActiva.isValid === true){
            notify(`Tiene operación iniciada con fecha hora ${operacionActiva.fechaHoraInicio}`,"success")
        }else{
            // notify(`No cuenta con una operación iniciada`,"error")
        }
    },[operacionActiva])

    const [rotacion, setRotacion] = useState(0);
    const [zoom, setZoom] = useState(1);

    const toggleRotacion = () => {
      // Incrementa el estado de rotación en 90 grados con cada clic
        setRotacion((rotacion + 90) % 360);
    };

    const toggleZoom = () => {
        if (zoom === 1) {
            setZoom(1.2);
        } else if (zoom === 1.2) {
            setZoom(1.5);
        }else if (zoom ===1.5){
            setZoom(1.8);
        } else {
            setZoom(1);
        }
    };
    
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    
    const handleMouseDown = (e) => {
        if (e.button === 2) {
            setRotacion(0);
            setZoom(1);
            setDragOffset({ x: 0, y: 0 });
        } else {
            setIsDragging(true);
            setDragStart({ x: e.clientX, y: e.clientY });
        }
    };
    const handleDoubleClick = () => {
        setRotacion(0);
        setZoom(1);
        setDragOffset({ x: 0, y: 0 });
    };
    
    const handleMouseMove = (e) => {
        if (isDragging) {
            const x = e.clientX - dragStart.x + dragOffset.x;
            const y = e.clientY - dragStart.y + dragOffset.y;
            setDragOffset({ x, y });
        }
    };
    
    const handleMouseUp = () => {
        setIsDragging(false);
        setDragStart({ x: 0, y: 0 });
    };








    return (
        <>
            <audio ref={audioRecarga} src={ sonidoRecarga} />
            <ContenedorParametros titulo='Recargas'>
                <div className='mt-2 flex justify center  z-50'>
                    <div className="cardv2">
                        <label for="switch2">
                        <input className='inputRecargav2 switch2' type="checkbox" id="switch2" onChange={cambiarEstadoUsuario} checked={switchDiponible}/>
                        <span className="switchv2"></span>
                        <span className="togglev2"></span>
                        </label>
                    </div>
                    <span 
                        className = {` ${switchDiponible? ' text-[#007d96] ' : ' text-gray-500 '}   `} >
                            {switchDiponible? 'Disponible' : 'Ausente'}
                    </span>
                </div>
                <div className='ml-5 flex flex-col center text-center'>
                    <span>Inicio Atención </span>
                    <span><i className='fa fa-clock'></i> 08:30 am </span>
                </div>

                <div className='ml-5 flex flex-col center text-center'>
                    <span>Atenciones </span>
                    <span><i className='fa fa-ticket'></i> 10 </span>
                </div>

                <div className='ml-5 flex flex-col center text-center'>
                    <span>Promedio </span>
                    <span><i className='fa fa-tachometer'></i> 2 min </span>
                </div>
            </ContenedorParametros>
                {/* tabla  */}
                <div className=" containerScroll w-full max-h-[60px] border mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla" >
                    
                    <table id={idTablaRecargas} className="table">
                        <tbody>
                            {   
                                recargas.length > 0 
                                ? recargas.map((r, i) => {
                                    const fechaRecarga = r.fechaHoraCreacion
                                    return (
                                        <tr key={r.codPeticion} onClick={() => {obtenerRecarga(r.codPeticion);}}>
                                            <td>{r.codPeticion}</td>
                                            <td className="text-center">{fechaRecarga}</td>
                                            <td className="text-center">{(r.nomPersona + ' ' + r.apePersona)}</td>
        
                                            <td className="text-right">S/{Number(r.montoVoucher).toFixed(2)}</td>
                                            
                                            {
                                            estadoBotonPintar === 0 &&
                                                <td className="text-center"><span className={formatState(r.codEstado)}>{r.nomEstado}</span></td>
                                            }
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
                {/* Fin tabla */}
                {/* datos Usuario */}
                <div className="mt-7 p-1 w-full  lg:text-center border flex justify-center  rounded border-b border-gray-500"> 
                    <div className='m-1 w-[220px]  '>
                        <i className='fa fa-ticket'></i>
                        <label className='mr-1'> {recarga.codPeticion} </label>
                    </div>
                    <div className='m-1 w-[400px] '>
                        <i className='fa fa-calendar'></i>
                        <label className='mr-1'> {recarga.fechaHoraCreacion} </label>
                    </div>
                        
                    <div className='m-1  w-[250px] '>
                        <i className='fa fa-mobile'></i>
                        <label className='mr-1'> {recarga.numCelularPrincipal}</label>
                    </div>

                    <div className='m-1 w-[500px] '>
                        <i className='fa fa-envelope-o'></i>
                        <label className='mr-1'> {recarga.correoPrincipal}</label>
                    </div>
                    
                    <div className='m-1 w-full '>
                        <i className='fa fa-user'></i>
                        <label className='mr-1'> {recarga.nomPersona} </label>
                    </div>

                    <div className=' text-center center  w-[120px] '>
                        <button  
                            onClick={() => listarHistorialRecargas(recarga.codUsuario)} 
                            className='px-2  bg-green-500 hover:bg-green-700 text-xl rounded' 
                            style={{zIndex:'100000'}}
                        >
                            <i  
                                data-tip 
                                data-for='toolHistorial' 
                                className="text-[17px] fa fa-list m-1" 
                            />
                            {/* <span className='text-[15px]'>
                                Historial
                            </span> */}
                        </button>
                    </div>
                </div>
                {/* Fin Datos Usuarios */}


                <div className='containerScroll mt-1 w-full h-[75%] justify-between flex '>

                    <div className='w-full  flex justify '>
        
                        <div className="rounded w-[450px] lg:w-full h-full relative  border border-gray">

                        <div 
                        className={`z-0 rounded w-[450px] h-[535px] relative mt-1 border border-gray `}
                        style={{ width: '450px', height: '535px', overflow: 'hidden' }}
                        >
                        
                        <div className= {` ${loadingConversion? '  ': 'hidden'} mt-[70px] ml-[30px] absolute`}>
                            <div className="absolute z-113212110 loadingT text-[25px]">Extrayendo texto...
                                <div className="spinner-sec spin-sec-oneT"></div>
                                <div className="spinner-sec spin-sec-twoT"></div>
                                <div className="spinner-sec spin-sec-threeT"></div>
                            </div>
                        </div>

                        <img 
                            src={fotoRecarga} 
                            className={`   rounded h-full w-full `}
                            // style={{ transform: `rotate(${rotacion}deg)` }}
                            style={{
                                // width: '100%',
                                // height: '100%',
                                transform: `rotate(${rotacion}deg) scale(${zoom})`,
                                // transform: `rotate(${rotacion}deg) scale(${zoom}) translate(${dragOffset.x}px, ${dragOffset.y}px)`,
                                position: 'relative',
                                top: `${dragOffset.y}px`,
                                left: `${dragOffset.x}px`,
                                
                                transition: 'transform 0.3s',
                                transformOrigin: 'center',

                                overflow: 'hidden' // Añadir overflow: hidden para recortar cualquier parte sobresaliente de la imagen
                            }}
                            alt="sin imagen" 
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            onDoubleClick={handleDoubleClick} // Doble clic para restablecer la posición

                            onMouseLeave={handleMouseUp} // Manejar el soltar el botón del mouse si se sale de la imagen
                        />

                        <button 
                            data-tip 
                            data-for='toolRedireccionarFoto' 
                            className='absolute right-0 bottom-0 bg-blue-500 hover:bg-blue-700 text-xl rounded' 
                            style={{zIndex:'100000'}}
                        >
                            <a  
                                className="m-1 fa fa-share" 
                                target="_blank" 
                                href={`${fotoRecarga}`} 
                                rel="noopener noreferrer" 
                            >
                            </a>
                            <Tooltip id='toolRedireccionarFoto' >Abrir Foto</Tooltip>
                        </button>

                        <button 
                            className='absolute right-0 bottom-[90px] w-[28px] bg-green-800 hover:bg-green-700 text-xl rounded' 
                            // className={`flex rounded h-full w-full transform rotate-${rotacion}`}

                            style={{zIndex:'100000'}}
                            onClick={toggleZoom}
                        >
                            <i 
                                data-tip 
                                data-for='toolZoomFoto' 
                                className="fa fa-search-plus" 
                            />
                            <Tooltip
                                id='toolZoomFoto' 
                            >Zoom
                            </Tooltip>
                        </button>

                        <button 
                            className='absolute right-0 bottom-[60px] w-[28px] bg-green-800 hover:bg-green-700 text-xl rounded' 
                            // className={`flex rounded h-full w-full transform rotate-${rotacion}`}

                            style={{zIndex:'100000'}}
                            onClick={toggleRotacion}
                        >
                            <i 
                                data-tip 
                                data-for='toolGirarFoto' 
                                className="fa fa-retweet" 
                            />
                            <Tooltip
                                id='toolGirarFoto' 
                            >Girar
                            </Tooltip>
                        </button>

                        <button 
                            onClick={()=>extraerTexto(fotoRecarga)} 
                            className='absolute right-0 bottom-[30px] w-[28px] bg-green-500 hover:bg-green-700 text-xl rounded' 
                            style={{zIndex:'100000'}}>
                            <i 
                                data-tip 
                                data-for='toolExtraerTexto'
                                className="fa fa-eye"
                            />

                            <Tooltip id='toolExtraerTexto'>Extraer Texto</Tooltip>

                            <Tooltip id='toolRedirigirBanco'>Abrir Banca por Internet </Tooltip>

                        </button>

                        {/* rotate-90 scale-150 */}
                        
                    </div>


                        </div>

                        <div className=" border text-center lg:text-center border-gray-500 ml-2 mt-1 rounded justify-center  ">
                            <div className='w-[260px] lg:w-full lg:text-center '   >
                                <div className=" w-full flex flex-col rounded" >

                                    <div className='mt-5 flex flex-col'>
                                        <label className=''> Fecha</label>
                                        <div className="">
                                            <DatePickerABX 
                                                date={recargaDate} 
                                                setDate={setRecargaDate} 
                                                onChange={(e)=>{editarValorRecarga("fechaOperacion", e.target.value)}}
                                                time={true} 
                                                classNameTotal={ `caret-input  text-white h-[30px] rounded px-4  bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center  caret-input`  }
                                            />
                                        </div>
                                    </div>

                                    <div className='mt-5 flex flex-col'>
                                        <label className=''>Banco</label>

                                        <select
                                            className={`mx-2 caret-input text-center text-white  h-[30px] rounded px-2  bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500   caret-input containerScroll`} 
                                            onChange={(e) => {
                                                const valorSeleccionado = e.target.value;
                                                editarValorRecarga('codEntidadBancaria', valorSeleccionado);
                                            
                                                const bancoSeleccionado = bancos.find(
                                                    (banco) => banco.codEntidadBancaria == valorSeleccionado
                                                );
                                                
                                                if (bancoSeleccionado) {
                                                    setUrlBancoElegido(bancoSeleccionado.urlPaginaOficialEntidadBancaria);
                                                    setImagenBanco(bancoSeleccionado.urlLogoEntidadBancaria);
                                                }else{
                                                    setUrlBancoElegido("");
                                                    setImagenBanco("https://static.vecteezy.com/system/resources/previews/020/716/209/original/flat-icon-bank-bank-icon-where-to-keep-money-illustration-of-saving-in-the-bank-free-png.png");
                                                }
                                            }}
                                            defaultValue={recarga.codEntidadBancaria}
                                        >
                                            <option  key={0} value={0}>-- Seleccione un Banco --</option>
                                            {
                                                bancos?.map(banco => {
                                                    // return <option className='px-5 ' key={banco.codEntidadBancaria} value={banco.codEntidadBancaria}>{banco.abrevEntidadBancaria.split('~')[0]}</option>
                                                    return <option className='px-5 ' key={banco.codEntidadBancaria} value={banco.codEntidadBancaria}>{banco.abrevEntidadBancaria} | {banco.cuentaBancaria} | {banco.cci} </option>
                                                })
                                            }   
                                        </select>
                                    </div>

                                    <div className='mt-5 w-full  flex flex-col'>
                                        <label className=''> N° Operación
                                        <button 
                                            data-tip 
                                            // data-for={nroOperacionValido? 'toolNumOpValido': 'toolNumOpInvalido'}
                                            data-for={ "toolTipNumOperacion"}
                                            className={`${nroOperacionValido.isValid? 'hidden fa fa-check' : 'fa fa-times' } ${nroOperacionValido.isValid? ' text-green-400 hover:text-green-500' : 'text-red-500 hover:text-red-500' }   right-0  h-[25px] rounded mr-[15px] px-3 w-[40px] h-[30px]  ` }
                                            onClick={
                                                nroOperacionValido? () => {
                                                    validarNroOperacion();
                                                    notify(
                                                        nroOperacionValido.isValid? 
                                                            nroOperacionValido.content 
                                                            :
                                                            nroOperacionValido?.exceptions[0].description,
                                                            nroOperacionValido.isValid?
                                                                "success"
                                                                :
                                                                "error"
                                                        ) 
                                                    }
                                                    :
                                                    ()=> notify("Debe ingresar un número de operación válido","error")
                                            }

                                            
                                        >
                                        </button>
                                        </label>
                                        <input 
                                            onChange={(e)=>{editarValorRecarga('nroOperacion',e.target.value)}} 
                                            defaultValue={recarga.nroOperacion} 
                                            className={`mx-2 caret-input  text-white  h-[30px] rounded px-2 bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center  `}
                                            // disabled={recarga.codEstado === 50 ? false : true} 
                                            // onKeyPress={(e) => {soloNumero(e,e.target)}}
                                        />
                                            <Tooltip id={'toolTipNumOperacion'}>
                                                {`${nroOperacionValido.isValid? ' ' : 'Ya se encuentra registrado en el sistema'}`}
                                            </Tooltip>
                                            {/* <Tooltip id='toolValidarNOperacion'>Validar Número de Operación </Tooltip>
                                            <Tooltip id='toolNumOpValido'>El número es válido</Tooltip>
                                            <Tooltip id='toolNumOpInvalido'>El número ya se encuentra registrado</Tooltip> */}

                                    </div>
                                
                                    <div className=' w-full mt-5  flex flex-col'>
                                        <label className=' '> Monto</label>                                    
                                        <input
                                                onChange={(e) => editarValorRecarga('montoVoucher',e.target.value )} 
                                                value={recarga.montoVoucher} 
                                                // className={`ml-3 text-white h-[30px] rounded px-4 w-[120px] bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 h-[40px] text-center text-[20px] caret-input `}
                                                className={`mx-2 caret-input text-white rounded bg-zinc-900 text-[25px] focus:outline-none focus:ring-1 focus:ring-blue-500 h-[35px]  text-center caret-input `}
                                                onKeyPress={(e) => soloDecimal(e, e.target)}
                                                onFocus={(e) => e.target.select()}
                                                onBlur={(e) => editarValorRecarga('montoVoucher', e.target.value)}
                                                // disabled={recarga.codEstado === 50 ? false : true}
                                                // onBlur={(e) => Number(e.target.value).toFixed(2)}
                                                />
                                    </div>

                                    <div className='mt-5  w-full text-center flex flex-col'>
                                        <label className=''>Comentario</label>
                                        <input 
                                            onChange={(e)=>editarValorRecarga('comentario',e.target.value)} 
                                            defaultValue={recarga.comentario} 
                                            className={`mx-2 caret-input  text-white h-[30px] rounded px-2  bg-zinc-900 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center  caret-input `}
                                        />
                                    </div>

                                    <div className='mt-5 text-xl w-full text-center flex flex-col'>
                                        <button className='p-2 mx-4 my-2 rounded bg-green-500 hover:bg-green-800'>
                                            Recargar 
                                        </button>
                                        <button className='p-2 mx-4 my-2 rounded bg-red-500 hover:bg-red-800'>
                                            Denegar 
                                        </button>
                                        
                                    </div>

                                
                                </div>
                            </div>
                            
                        </div>

                    </div>

                    {/* Frame del banco */}
                    {/* <div className='h-[94%] ml-2 w-full  rounded'>
                        <div className='flex justify '>

                        {bancos?.length > 0
                        ? bancos?.map((banco, index) => (
                            
                            <div className=' text-xs p-1 border cursor-pointer hover:bg-green-800 rounded-t border-gray-500 '>

                                <button 
                                    onClick={()=>loadURL()}
                                    // href={banco.urlPaginaOficialEntidadBancaria}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >
                                    <img className='w-[20px] h-[20px] ' src={banco.urlLogoEntidadBancaria} alt=''/>

                                </button>
                                    <span className='mx-2'>{banco.abrevEntidadBancaria}</span>
                            </div>                                
                        ))
                        :
                            <div>
                                <span>No se encontraron bancos registrados</span>
                            </div>
                        }
                        </div> */}
                         
                        <iframe
                            width="100%"
                            height="100%"
                            border="1px solid gray"
                            src="https://empresas.interbank.pe/login"
                            title="BANCO"
                            // allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            // allowFullScreen
                        ></iframe> 


                </div>

                    

            <Modal  // MODAL DE DENEGAR
                isOpen={isOpenModalDenegar} 
                closeModal={closeModalDenegar} 
                action={()=>{rechazarRecarga();guardarEditarMensaje()}}
                title= {"Denegar recarga"}
                spinner={spinner}
                textButtons={{ confirm: 'Denegar', denied:'Cancelar' }}
                validButton ={{ confirm: true, denied: true }} 
            >
                <>
                    <div className="flex gap-8 items-center flex-wrap justify-center">
                        <div className="w-[600px] px-4">
                        
                            <label className="text-center">Motivo denegación (Se enviará al usuario):</label>
                            {/* <textarea autoFocus={true} onChange={(e) =>editarValorRecarga('comentario', e.target.value)} className={`${classNameInput2} caret-input `} >Estimado Cliente, su recarga fue Denegada, por favor podría' </textarea> */}
                            <textarea 
                                autoFocus={true} 
                                onChange={(e) =>{
                                    editarValorRecarga('comentarioDenegar', e.target.value);
                                    editarValorChat('mensaje', e.target.value);
                                    editarValorChat("codPeticion",recarga.codPeticion);
                                    editarValorChat("codUsuarioDestino", recarga.codUsuario);
                                    editarValorChat("codUsuario", recarga.codUsuario);
                                    editarValorChat("nomUsuario", recarga)
                                }} 
                                className={`${classNameInput2} `}> </textarea>
                            
                            <div className='relative mt-[8px] text-right max-w-full'> 
                                <label className='mr-[10px]'>Habilitar Conversación</label>
                                <label className="switch top-1">
                                    {/* <input className='' type="checkbox" onChange={(e)=> {setComentarioBloqueo(e.target.checked ? true : false ); editarValorRecarga('sugerirBloqueo',e.target.checked? 5 : 0)}}/> */}
                                    <input
                                        className='' 
                                        type="checkbox" 
                                        onChange={(e)=>editarValorChat('chatActivo', e.target.checked? true : false)}
                                    />
                                    <div className="slider"></div>
                                </label>
                            </div>
                            
                            
                            <div className='relative mt-[8px] text-right max-w-full'> 
                                <label className='mr-[10px]'>Amonestar Usuario</label>  
                                <label className="switch top-1"> 
                                    <input 
                                        className='' 
                                        type="checkbox" 
                                        onChange={(e)=> {
                                                const checkeado = e.target.checked? true : false  
                                                editarValorRecarga('amonestaUsuario', checkeado)
                                                setVerInputComentarioBloqueo(checkeado || recarga.sugiereBloqueo); 
                                                !(checkeado || recarga.sugiereBloqueo) && editarValorRecarga("motivoAmonestacionBloqueo","") 
                                            }
                                        }
                                    />
                                    <div className="slider"></div>
                                </label>
                            </div>
                                
                            <div className='relative mt-[8px] text-right max-w-full'> 
                                <label className='mr-[10px]'>Sugerir Bloqueo</label>
                                <label className="switch top-1">
                                    <input 
                                        className='' 
                                        type="checkbox" 
                                        onChange={(e)=> {
                                                const checkeado = e.target.checked? true : false  
                                                editarValorRecarga('sugiereBloqueo',checkeado)
                                                setVerInputComentarioBloqueo(checkeado || recarga.amonestaUsuario); 
                                                !(checkeado || recarga.amonestaUsuario) && editarValorRecarga("motivoAmonestacionBloqueo","") 
                                            }
                                        }
                                    />
                                    <div className="slider"></div>
                                </label>
                            </div>

                            <div className={`w-[600px] px-4  `}>
                                <label className="text-center">Comentario de amonestación y/o bloqueo:</label>
                                <textarea 
                                    onChange={(e) =>{editarValorRecarga('motivoAmonestacionBloqueo', e.target.value)}} 
                                    className={`${classNameInput2} ${verInputComentarioBloqueo? '  bg-zinc-900 ' : ' bg-zinc-700 ' }`}
                                    disabled = {!verInputComentarioBloqueo}
                                    value={recarga.motivoAmonestacionBloqueo}
                                    autoFocus={true}
                                > 
                                </textarea>
                            </div>

                        </div>

                    </div>
                </>                
            </Modal> 
        
            <Modal   //HISTORIAL DE LAS ULTIMAS 10 RECARGAS
                isOpen={isOpenHistorial} 
                closeModal={closeModalHistorial} 
                action={closeModalHistorial}
                title= {"Historial 10 Ultimas Recargas"}
                spinner={spinner}
                textButtons={{ confirm: 'Cerrar', denied:'Cancelar'}}
                validButton ={{confirm: true, denied: false}} 
            >
                <div className=" containerScroll max-h-[500px] mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                    <table className="tableResponsive">
                        <thead>
                            <tr>    
                                <th className="w-[30px]">N</th>
                                <th>COD</th>
                                <th>FECHA</th>
                                <th>COMENTARIO</th>
                                <th>MONTO</th>
                                <th>ESTADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {   
                                recargaHistorial.length > 0 
                                ? recargaHistorial.map((h, i) => {
                                    const fechaRecarga = h.fechaHoraCreacion.split('T')[0] + ' ' + h.fechaHoraCreacion.split('T')[1].split('.')[0]
                                    return (
                                        <tr key={h.codPeticion}>
                                            <td>{++i}</td>
                                            <td>{h.codPeticion}</td>
                                            <td className="text-center">{fechaRecarga}</td>
                                            <td className="text-center">{h.comentario}</td>
                                            <td className="text-center">{h.montoVoucher}</td>
                                            <td className="text-center"><span className={formatState(h.codEstado)}>{h.nomEstado}</span></td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan="10" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>

            </Modal>



            <Modal 
                isOpen={isOpenChatBeex} closeModal={closeModalChatBeex} action={{}}
                title= {`CHAT ONLINE [${recarga.codPeticion}] - ${recarga.nomUsuario}`} 
                spinner={spinner}
                // textButtons={{ confirm: 'Aceptar', denied:'cerrar'}}
                textButtons={{  denied:'cerrar'}}
                // validButton ={{confirm: true, denied: true}}
                validButton ={{ denied: true}}
            >
                <>
                    <div className='h-[450px] '>
                        <ol  className="chat  containerScroll rounded h-[400px] w-[420px]">
                                {   
                                    chat.length > 0 
                                    ? chat.map((c, i) => {
                                        return (
                                            // <li className="other">
                                            <li ref={i === chat.length - 1 ? ultimoElementoRef : null} {... i == chat.length-1 ? handleFocus(ultimoElementoRef):''} key={i} className={`${c.codAccesoTipo == 1? 'other' : 'self'}`} >
                                                {/* <div className='border '> {c.codAccesoTipo} - {c.mensaje} - {c.fechaHoraCreacion} - {c.chatActivo}</div> */}
                                                <div className="avatar">
                                                    <img  src={c.codAccesoTipo == 1? fotoChat : fotobeexserver} className='w-[50px]' alt=""/> 
                                                </div>
                                                <div className="msg">
                                                    <p>{c.mensaje}</p>
                                                    <time>{c.fechaHoraCreacion}</time>
                                                </div>
                                            </li>
                                        )
                                    })
                                    : <div colSpan="10" className="text-center w-[100px]">No hay Chat.</div>
                                }
                        </ol>


                        <div className='mt-5 border-t  flex items-center'>
                            <textarea id='txtComentario' autoFocus={true} value={chat.mensaje} placeHolder="escriba aqui..." className={`text-white h-[50px] rounded mt-[10px] px-4 w-[350px] bg-zinc-900 text-base focus:outline-none focus:ring-1 focus:ring-blue-500 caret-input  `} 
                                onChange={(e) =>{editarValorRecarga('comentarioDenegar', e.target.value);editarValorChat('mensaje', e.target.value);editarValorChat("codPeticion",recarga.codPeticion);editarValorChat("codUsuarioDestino", recarga.codUsuario);editarValorChat("codUsuario", recarga.codUsuario);editarValorChat("nomUsuario", recarga.nomUsuario)}}> 
                            </textarea>
                            <button className='bg-green-500 p-3 h-12 mt-2 rounded  ml-2' onClick={()=>enviarMensaje(recarga.codPeticion)}>  Enviar </button>
                        </div>

                        <div className='relative p-5 text-left w-[70%]'> 
                            <label className='mr-[10px]'>Habilitar Conversación</label>
                            <label className="switch top-1">
                                {/* <input className='' type="checkbox" onChange={(e)=> {setComentarioBloqueo(e.target.checked ? true : false ); editarValorRecarga('sugerirBloqueo',e.target.checked? 5 : 0)}}/> */}
                                <input defaultChecked className='' type="checkbox" defaultValue={chat.chatActivo} onChange={(e)=>{editarValorChat('chatActivo', e.target.checked? true : false);obtenerChat(recarga.codPeticion)}}/>
                                <div className="slider"></div>
                            </label>
                        </div>
                    </div>
                </>                
            </Modal>

        </>
    )
}
